const SESSION_PLAYER_ID_KEY = 'dice1k_session_playerId';
const RESERVED_PLAYER_ID_PREFIX = 'dice1k_reserved_playerId_';

function normalizeGameId(gameId: string): string {
  return gameId.trim().toUpperCase();
}

function reservedPlayerIdKey(gameId: string): string {
  return `${RESERVED_PLAYER_ID_PREFIX}${normalizeGameId(gameId)}`;
}

export function getSessionPlayerId(): string | null {
  try {
    return window.sessionStorage.getItem(SESSION_PLAYER_ID_KEY);
  } catch {
    return null;
  }
}

export function setSessionPlayerId(playerId: string): void {
  try {
    window.sessionStorage.setItem(SESSION_PLAYER_ID_KEY, playerId);
  } catch {
    // Ignore errors on purpose, e.g. in private mode
  }
}

export function clearSessionPlayerId(): void {
  try {
    window.sessionStorage.removeItem(SESSION_PLAYER_ID_KEY);
  } catch {
    // Ignore errors
  }
}

export function getReservedPlayerId(gameId: string | null | undefined): string | null {
  if (!gameId) return null;
  try {
    return window.sessionStorage.getItem(reservedPlayerIdKey(gameId));
  } catch {
    return null;
  }
}

export function setReservedPlayerId(gameId: string, playerId: string): void {
  try {
    window.sessionStorage.setItem(reservedPlayerIdKey(gameId), playerId);
  } catch {
    // Ignore errors on purpose, e.g. in private mode
  }
}

export function clearReservedPlayerId(gameId?: string | null): void {
  try {
    if (gameId) {
      window.sessionStorage.removeItem(reservedPlayerIdKey(gameId));
      return;
    }
    const keysToRemove: string[] = [];
    for (let index = 0; index < window.sessionStorage.length; index += 1) {
      const key = window.sessionStorage.key(index);
      if (!key || !key.startsWith(RESERVED_PLAYER_ID_PREFIX)) continue;
      keysToRemove.push(key);
    }
    keysToRemove.forEach((key) => window.sessionStorage.removeItem(key));
  } catch {
    // Ignore errors
  }
}
